/**
 * Upgradable plan component.
 */
import Container from '@components/atoms/container/upgradablePlanContainer';
import Direction from '@shared/types/enums/direction';
import Plan from '@shared/classes/plan';
import Text from '@components/atoms/text/upgradablePlanText';
import TranslationManager from '@shared/assets/locale/translationsManager';

/**
 * Props for the Upgradable plan component.
 *
 * @param {Direction} direction - Direction of the component
 * @param {boolean} fontBold - Whether to use bold font
 * @param {number} fontSize - Size of the font
 * @param {Plan | null} plan - Plan to display
 * @param {boolean} separator - Whether to display a separator
 */
interface Props {
  direction?: Direction;
  fontBold?: boolean;
  fontSize?: number;
  plan?: Plan | null;
  separator?: boolean;
}

/**
 * Renders the upgradable plan component.
 * Displays the plan name and the separator text.
 */
export default function UpgradablePlan({
  direction = Direction.HORIZONTAL,
  fontBold = false,
  fontSize,
  plan,
  separator,
}: Props) {
  return plan?.name ? (
    <Container direction={direction}>
      {/* Available in */}
      <Text id={'separatorText'} direction={direction} fontSize={fontSize}>
        {separator ? ' · ' : null}
        {TranslationManager.get('COMPONENTS.UPGRADE_PLAN.AVAILABLE_IN')}
      </Text>
      {/* Plan title */}
      <Text
        id={'titleText'}
        color={plan?.colorHex}
        direction={direction}
        fontBold={fontBold}
        fontSize={fontSize}
      >
        {plan.name}
      </Text>
    </Container>
  ) : null;
}
